"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MenuItemCheckbox", {
    enumerable: true,
    get: function() {
        return MenuItemCheckbox;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useMenuItemCheckbox = require("./useMenuItemCheckbox");
const _renderMenuItemCheckbox = require("./renderMenuItemCheckbox");
const _useMenuItemCheckboxStylesstyles = require("./useMenuItemCheckboxStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const MenuItemCheckbox = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useMenuItemCheckbox.useMenuItemCheckbox_unstable)(props, ref);
    (0, _useMenuItemCheckboxStylesstyles.useMenuItemCheckboxStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useMenuItemCheckboxStyles_unstable')(state);
    return (0, _renderMenuItemCheckbox.renderMenuItemCheckbox_unstable)(state);
});
MenuItemCheckbox.displayName = 'MenuItemCheckbox';
